import React, { useState, useEffect, useCallback } from 'react';
import DataTable from '@/components/DataTable';
import ExportExcelButton from '@/components/ExportExcelButton';
import SectionCard from '../../components/SectionCard';

const PAGE_SIZE = 20;

// Tabla de registros (solo lectura) con paginación del lado del servidor y botón de
// exportar a Excel. La reutilizan los reportes "Recepción de ropa sucia" y
// "Alistamientos" del Reporte 360 v2.
//
// - fetchPage({ page, limit }) -> { data, totalRecords }
// - exportService({ query, limit, page }) -> array | { data } (contrato de ExportExcelButton)
// - resetKey: cambia cuando cambian los filtros aplicados; vuelve a la página 1.
const RegistrosTableSection = ({
  title,
  hint,
  columns,
  fetchPage,
  resetKey,
  exportService,
  exportColumns,
  exportFileName,
  exportDataMapper,
}) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, totalRecords: total } = await fetchPage({ page, limit });
      setRows(Array.isArray(data) ? data : []);
      setTotalRecords(Number(total) || 0);
    } catch (e) {
      setError(e.message || 'Error al cargar los registros');
      setRows([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
    // fetchPage se recrea con cada filtro aplicado (resetKey)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, resetKey]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SectionCard
      title={title}
      hint={hint ?? `${totalRecords.toLocaleString('es-CO')} registros en el periodo.`}
      error={error}
      onReload={load}
      loading={loading}
      action={
        <ExportExcelButton
          service={exportService}
          columns={exportColumns}
          fileName={exportFileName}
          dataMapper={exportDataMapper}
        />
      }
    >
      <DataTable
        data={rows}
        columns={columns}
        isLoading={loading}
        page={page}
        limit={limit}
        totalRecords={totalRecords}
        onPageChange={setPage}
        onLimitChange={setLimit}
        hideActionsColumn
        headerClassName="bg-[#0F3460] [&_th]:text-white"
      />
    </SectionCard>
  );
};

export default RegistrosTableSection;
